import { createReducer, on } from '@ngrx/store';
import { Material } from '@app/store/shared/models';
import { ROWS_PER_PAGE } from '@shared/components';
import { materialsActions } from '../actions/materials.actions';
import { GetMaterialsValue, MaterialLookup } from '../models';

export interface MaterialsState {
    loaded: boolean | null;
    loading: boolean;
    materials: Material[];
    value: GetMaterialsValue;
    total: number;
    lookupLoaded: boolean | null;
    lookup: MaterialLookup[];
}

export const initialState: MaterialsState = {
    loaded: null,
    loading: false,
    materials: [],
    value: { page: 1, limit: ROWS_PER_PAGE[0] },
    total: 0,
    lookupLoaded: null,
    lookup: [],
};

export const materialsReducer = createReducer(
    initialState,
    on(materialsActions.getMaterials, (state, { value }): MaterialsState => ({ ...state, value, loading: true })),
    on(materialsActions.getMaterialsSuccess, (state, { payload }): MaterialsState => ({
        ...state,
        loading: false,
        loaded: true,
        materials: payload.items,
        total: payload.total,
    })),
    on(materialsActions.getMaterialsError, (state): MaterialsState => ({ ...state, loading: false, loaded: false })),
    // Lookup - a loaded one stays loaded while it refetches, so a revisited view shows its options at once.
    on(materialsActions.getMaterialsLookup, (state): MaterialsState => ({ ...state, lookupLoaded: state.lookupLoaded || null })),
    on(materialsActions.getMaterialsLookupSuccess, (state, { payload }): MaterialsState => ({ ...state, lookupLoaded: true, lookup: payload })),
    on(materialsActions.getMaterialsLookupError, (state): MaterialsState => ({ ...state, lookupLoaded: false })),
    on(materialsActions.clear, (): MaterialsState => ({ ...initialState })),
);
